package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SendW500Rounded: ImageVector
    get() {
        if (_sendW500Rounded != null) {
            return _sendW500Rounded!!
        }
        _sendW500Rounded = Builder(name = "SendW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(789.85f, 522.02f)
                lineTo(176.24f, 781.3f)
                quadToRelative(-22.87f, 9.44f, -43.26f, -3.85f)
                quadToRelative(-20.39f, -13.3f, -20.39f, -38.17f)
                verticalLineToRelative(-518.56f)
                quadToRelative(0.0f, -24.87f, 20.39f, -38.17f)
                quadToRelative(20.39f, -13.29f, 43.26f, -3.85f)
                lineToRelative(613.61f, 259.28f)
                quadToRelative(28.11f, 12.43f, 28.11f, 42.02f)
                quadToRelative(0.0f, 29.59f, -28.11f, 42.02f)
                close()
                moveTo(200.0f, 676.41f)
                lineTo(665.15f, 480.0f)
                lineTo(200.0f, 283.59f)
                verticalLineToRelative(132.82f)
                lineTo(443.59f, 480.0f)
                lineTo(200.0f, 543.59f)
                verticalLineToRelative(132.82f)
                close()
                moveTo(200.0f, 676.41f)
                verticalLineToRelative(-392.82f)
                verticalLineToRelative(392.82f)
                close()
            }
        }
        .build()
        return _sendW500Rounded!!
    }

private var _sendW500Rounded: ImageVector? = null
